import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ManagementService } from '../../services/management.service';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { CountryService } from '../../../services/country.service';
import { IComboBaseCountry } from '../../../interfaces/base/base.interface';

@Component({
  selector: 'app-country-edit-modal',
  templateUrl: './country-edit-modal.component.html',
  styleUrl: './country-edit-modal.component.scss',
  providers: [DialogService],
})
export class CountryEditModalComponent {
  @Input() visible: boolean = false;
  @Input() countryId: number | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() registerComplete = new EventEmitter<void>();

  isDisabled: boolean = true;
  country: string | null = null;
  codeCountry: string | null = null;
  phoneCode: string | null = null;
  isLoading: boolean = false;

  hasInteracted: { [key: string]: boolean } = {
    country: false,
    codeCountry: false,
    phoneCode: false,
  };

  constructor(
    private managementService: ManagementService,
    private countryService: CountryService,
    private dialogService: DialogService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countryId'] && changes['countryId'].currentValue !== null) {
      this.loadAreaData();
    }
  }

  private loadAreaData(): void {
    this.isLoading = true;
    if (!this.countryId) return;

    this.countryService.comboCountry().subscribe({
      next: (countryData) => {
        const selectedCountry = countryData.find(
          (country) => String(country.key) === String(this.countryId)
        );
        if (selectedCountry) {
          this.country = selectedCountry.text;
          this.codeCountry = selectedCountry.countryCode; // CAMBIAR POR PHONE CODE
          this.phoneCode = selectedCountry.phonecode; // CAMBIAR POR CODE COUNTRY
        }

        this.hasInteracted['country'] = true;
        this.hasInteracted['codeCountry'] = true;
        this.hasInteracted['phoneCode'] = true;
        this.isLoading = false;
        this.validateForm();
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error al obtener el área:', err);
      },
    });
  }

  onChangeInput(event: any, type: string) {
    this.hasInteracted[type] = true;
    switch (type) {
      case 'country':
        this.country = event;
        break;
      case 'codeCountry':
        this.codeCountry = event;
        break;
      case 'phoneCode':
        this.phoneCode = event;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.validateForm();
  }

  validateForm() {
    this.isDisabled = !(this.country && this.phoneCode && this.codeCountry);
  }

  onEdit() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    if (this.countryId) {
      const countryId = this.countryId;
      const request = {
        nameCountry: this.country,
        codeCountry: this.codeCountry,
        phoneCode: this.phoneCode,
      };

      const formData = new FormData();

      const appendIfDefined = (key: string, value: any) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      };

      Object.entries(request).forEach(([key, value]) =>
        appendIfDefined(key, value)
      );

      this.managementService.updateCountry(formData, countryId).subscribe({
        next: (response) => {
          loadingRef.close();
          const ref = this.dialogService.open(ModalSuccessComponent, {
            header: '',
            data: {
              text: 'El área ha sido actualizada con éxito.',
              title: '¡Éxito!',
              icon: 'pi pi-check-circle',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.registerComplete.emit();
          this.closeDialog();
          this.resetForm();
        },

        error: (err) => {
          loadingRef.close();

          const ref = this.dialogService.open(ModalRejectComponent, {
            header: '',
            data: {
              text:
                err.error?.error ||
                'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
              title: '¡Lo sentimos!',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.resetForm();
          this.closeDialog();
        },
      });
      // this.closeDialog();
    }
  }

  resetForm() {
    this.country = null;
    this.codeCountry = null;
    this.phoneCode = null;

    this.hasInteracted = {
      country: false,
      codeCountry: false,
      phoneCode: false,
    };
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
